import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronRight, ChevronDown } from 'lucide-react';
import './styles/section.css';

/**
 * A collapsible section component with header and content
 * @param {string} title - Section title
 * @param {React.ReactNode} children - Section content
 * @param {boolean} defaultOpen - Whether section is open by default
 * @param {React.ReactNode} icon - Optional icon for the section
 */
export default function Section({ title, children, defaultOpen = false, icon }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <div className={`section ${isOpen ? 'section-open' : ''}`}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="section-header"
      >
        <div className="section-title">
          {icon && <span className="section-icon">{icon}</span>}
          <h3>{title}</h3>
        </div>
        {isOpen ? <ChevronDown className="toggle-icon" /> : <ChevronRight className="toggle-icon" />}
      </button>
      
      {isOpen && (
        <div className="section-content">
          {children}
        </div>
      )}
    </div>
  );
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  icon: PropTypes.node
};